import React, { createContext, useContext, useState, useEffect } from 'react';
import esTranslations from '../translations/es.json';
import enTranslations from '../translations/en.json';

const LanguageContext = createContext();

const translations = {
  es: esTranslations,
  en: enTranslations
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('es');

  useEffect(() => {
    // Get language from URL path
    const updateLanguageFromPath = () => {
      const path = window.location.pathname;
      const langFromPath = path.split('/').filter(Boolean)[0];
      
      if (langFromPath === 'en' || langFromPath === 'es') {
        setLanguage(langFromPath);
      } else {
        setLanguage('es'); // Default to Spanish
      }
    };

    updateLanguageFromPath();
    
    // Listen for navigation changes
    window.addEventListener('popstate', updateLanguageFromPath);
    return () => window.removeEventListener('popstate', updateLanguageFromPath);
  }, []);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      value = value?.[k];
    }
    
    return value || key;
  };

  const changeLanguage = (lang) => {
    setLanguage(lang);
    const currentPath = window.location.pathname;
    // Extract the path without language prefix
    const pathMatch = currentPath.match(/^\/(es|en)(\/.*)?$/);
    if (pathMatch) {
      const pathWithoutLang = pathMatch[2] || '';
      window.location.href = `/${lang}${pathWithoutLang}`;
    } else {
      window.location.href = `/${lang}${currentPath === '/' ? '' : currentPath}`;
    }
  };

  return (
    <LanguageContext.Provider value={{ language, t, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
